<ion-app>
  <ion-menu menuId="side-menu" contentId="main" swipe-gesture="false">
    <ion-header>
      <ion-toolbar [color]="!!status ? 'dark' : 'primary'">
        <ion-title>Menu</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-item
          button="true"
          (click)="onClickOperations()"
          data-testid="menu-operations"
        >
          <ion-icon
            aria-hidden="true"
            color="primary"
            name="list-outline"
            slot="start"
          ></ion-icon>
          <ion-text> Dive Operations </ion-text>
        </ion-item>
        <ion-item button="true" (click)="onClickAttachments()">
          <ion-icon
            color="primary"
            name="document-outline"
            slot="start"
          ></ion-icon>
          <ion-text> Attachments </ion-text>
        </ion-item>
        <ion-item
          button="true"
          (click)="onClickSettings()"
          data-testid="menu-settings"
        >
          <ion-icon
            color="primary"
            name="settings-outline"
            slot="start"
          ></ion-icon>
          <ion-text> Settings </ion-text>
        </ion-item>
        <ion-item button="true" (click)="onClickCompany()">
          <ion-icon
            color="primary"
            name="business-outline"
            slot="start"
          ></ion-icon>
          <ion-text> Company </ion-text>
        </ion-item>
        <ion-item
          button="true"
          (click)="networkToggle()"
          data-testid="menu-network-toggle"
        >
          <ion-icon
            color="primary"
            name="wifi-outline"
            slot="start"
          ></ion-icon>
          <ion-text> Network </ion-text>
        </ion-item>
        <ion-item button="true" (click)="onClickLogout()">
          <ion-icon
            color="primary"
            name="log-out-outline"
            slot="start"
          ></ion-icon>
          <ion-text> Sign Out </ion-text>
        </ion-item>
      </ion-list>
    </ion-content>
    <ion-footer>
      <div class="ion-padding ion-text-center">
        <ion-text color="medium"><small>DOPA {{ appVersion }}</small></ion-text>
      </div>
    </ion-footer>
  </ion-menu>
  <ion-router-outlet id="main"></ion-router-outlet>
</ion-app>
